import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  headerDialogTitle: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },

  legend: {
    padding: '1rem 0 0.5rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    color: neutral['100'],
    '&.Mui-focused': {
      color: neutral['100'],
    },
  },
  radioGroup: {
    gap: '0.5rem',
  },
  radioOptionLabelTitle: {
    fontWeight: 400,
    lineHeight: '1.5rem',
  },
});
